export const ERROR_MSG = Object.freeze({
    PREVIOUS_BET_NOT_COMPLETED : 'PREVIOUS_BET_NOT_COMPLETED',
    SCORE_ALREADY_SCRATCHED: 'SCORE_ALREADY_SCRATCHED',
    NO_PLACED_BET_FOUND: 'NO_PLACED_BET_FOUND'
})

export const GAME_STATES = Object.freeze({
    IDLE : 'IDLE',
    FLAG_ANIMATION: 'FLAG_ANIMATION',
    API_FETCHING: 'API_FETCHING',
    SETUP_STATE: 'GAME_SETUP',
   
})

export const RESULTS = Object.freeze({
    PENDING: 'pending',
    LOST: 'lost',
    WON: 'won'
})

export const COMMENDATION = Object.freeze({
    NONE: 'none',
    NORMAL: 'normal',
    BIG : 'big',
    MEGA : 'mega',
    ULTRA : 'ultra',
    MINOR: 'minor',
    MAJOR: 'major',
    GRAND: 'grand'
})

export const URL = {
    BASE: process.env.REACT_APP_BACKEND_URL_HTTP
}

export const background =  {
    pig: 'main_bg_pig',
    chickens: 'main_bg_chicken'
}


export const WINS = Object.freeze({
    NORMAL: 'NORMAL_WIN',
    BIG: 'BIG_WIN',
    MEGA: 'MEGA_WIN',
    ULTRA: 'ULTRA_WIN'
})

export const JACKPOT = Object.freeze({
    MINOR: 'minor',
    MAJOR: 'major',
    GRAND: 'grand',
})